import {
  Box, 
  Chip, 
  Grid, 
  Button
} from "@mui/material";
import styled from "styled-components";
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

export const PageCard = styled(Box)(({ theme }) => ({
  // padding: `${theme.spacing(3, 2)} ${theme.spacing(3, 2)}`,
  padding: theme.spacing(4, 2),
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.palette.custom.borderRadius,
  alignItems: 'center',
  justifyContent: 'space-between',
  marginBottom: theme.spacing(4),
}));

interface StatusTagProps {
  status: 'Active' | 'Pending' | 'Blocked' | string;
}

export const StatusChip = styled(Chip)<StatusTagProps>(({ theme, status }) => ({
  fontWeight: 'bold',
  color: "#fff !important",
  height: '28px',
  padding: `${theme.spacing(1, 5)} !important`,
  display: 'flex !important',
  alignItems: 'center',
  justifyContent: 'center',
  width: 'fit-content',
  borderRadius: `${theme.spacing(1, 3)} !important`,
  textTransform: 'capitalize',
}))

interface CustomAccordionProps {
  status: 'Active' | 'Pending' | 'Blocked' | string;
  marginBottom: number;
}

export const CustomAccordion = styled(Box)<CustomAccordionProps>(({ theme, status, marginBottom }) => ({
  borderRadius: theme.palette.custom.borderRadius,
  padding: `${theme.spacing(3, 5)}`,
  border:  `1px solid ${theme.palette.grey[200]}`,
  alignItems: "center",
  justifyContent: "space-between",
  marginBottom: theme.spacing(marginBottom),
}));  

export const ExpandIcon = styled(ArrowForwardIosIcon)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontSize: '1rem !important',
  marginLeft: theme.spacing(1),
}));

export const CustomLink = styled(Box)(({theme}) => ({
  cursor: "pointer"
}))

export const VerificationContainer = styled(Grid)(({theme}) => ({
  
}));

export const VerificationImageContainer = styled(Grid)(({theme}) => ({
  marginTop: theme.spacing(0.5),
  // marginLeft: theme.spacing(0.1),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '& img': {
      // You'll need to define a max size for the icon so it doesn't break the layout
      width: '40px', 
      height: '40px',
  },
}))

export const ButtonGroupContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2), 
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
}));

const ActionButton = styled(Button)(({theme}) => ({
  padding: theme.spacing(1, 3),
  borderRadius: `${theme.spacing(1)} !important`,
  textTransform: 'capitalize',
  minWidth: '200px !important',
}))

export const RejectButton = styled(ActionButton)(({theme}) => ({
  borderColor: `${theme.palette.error.main} !important`,
  color: `${theme.palette.error.main} !important`,

  '&.Mui-disabled': {
    borderColor: `${theme.palette.grey[300]} !important`,
    color: `${theme.palette.grey[300]} !important`,
    opacity: 0.5
  }
}));

export const AcceptButton = styled(ActionButton)(({theme}) => ({
  borderColor: theme.palette.success.main,
  color: theme.palette.success.main,

  '&.Mui-disabled': {
    borderColor: `${theme.palette.grey[300]} !important`,
    color: `${theme.palette.grey[300]} !important`,
    opacity: 0.5
  }
  
  // '&:hover': {
  //   backgroundColor: theme.palette.success.main,
  //   color: theme.palette.white.main,
  // }
}))